<template>
    <div class="calendar-wrapper">
        <!-- Header -->
        <div class="calendar-headers">
            <div class="left-controls">
                <button @click="prevMonth">‹</button>
                <span class="month-title">{{ monthYear }}</span>
                <button @click="nextMonth">›</button>
                <button class="today-btn text-dark" @click="goToday">Today</button>
                <CButton color="primary" type="button" class="create-schedule-btn text-dark" @click="GoOpenSchedule()">
                    + Create Schedule</CButton>
            </div>
        </div>
    
        <!-- Calendar -->
        <div class="calendar-grid">
            <div class="day header" v-for="d in weekDays" :key="d">{{ d }}</div>
    
            <!-- <div v-for="(day, i) in daysInMonth" :key="i" class="day" :class="{ today: isToday(day.date), selected: selectedDate === day.date }" @click="selectDate(day.date)">
                            <span v-if="day.day">{{ day.day }}</span>
                        </div> -->
            <div v-for="(day, i) in daysInMonth" :key="i" class="day" :class="{ today: isToday(day.date), selected: selectedDate === day.date }" @click="selectDate(day.date)">
                <span v-if="day.day">{{ day.day }}</span>
    
                <!-- ✅ Show class count badge only if classes exist -->
                <div v-if="getClassCount(day.date) > 0" class="class-count-badge">
                    <i class="fa fa-book"></i>
                    <span>{{ getClassCount(day.date) }}</span>
                </div>
            </div>
        </div>
    
        <!-- Schedule -->
        <div class="schedule-container" v-if="selectedDate">
            <div class="schedule-header">
                <h3>Schedule</h3>
                <span class="date-label">{{ formatDisplayDate(selectedDate) }}</span>
            </div>
    
            <div v-if="selectedClasses.length" class="schedule-list">
                <!-- Existing Class Card -->
                <div v-for="(cls, idx) in sortedClasses" :key="idx" class="schedule-card"  :class="{ 'cancelled-card': cls.announcement }">
                    <div class="time-label">{{ cls.startTime }}</div>
    
                    <div class="class-info">
                        <div class="class-status" v-if="cls.status">
                            <span class="status-dot"></span> {{ cls.status }}
                        </div>
                        <div v-if="cls.announcement" class="cancel-label">
Cancelled Class
</div>
                        <div class="class-title">{{ cls.code }} - {{ cls.name }}</div>
                        <div class="class-teacher">with {{ cls.teacher }}</div>
                        <div class="class-time">Time: {{ cls.startTime }} - {{ cls.endTime }}</div>
                        <div v-if="cls.zoomLink != 'no link'">
                            <div class="class-time">Zoom Password: {{ cls.password }}</div>
                            <div class="class-time">Zoom Meeting Id: {{ cls.meetingId }}</div>
                            <div class="class-time">Zoom Link: {{ cls.zoomLink }}</div>
                        </div>
                        <div v-if="cls.announcement" class="announcement-box">
    <strong>Announcement:</strong> {{ cls.announcement }}
</div>
                        <div class="class-time">Replace Date: {{ cls.announcementScheduleDate | moment("DD/MM/YYYY") }}</div>
                        <div class="class-time">Time: {{ cls.announcementStartTime | moment("HH:MM:ss")  }} - {{ cls.announcementEndTime | moment("HH:MM:ss")  }}</div>
                        <!-- Modules -->
                        <div class="modules-grid mt-3">
                            <div class="class-title mt-2">Uploaded Modules:</div>
                            <div v-for="mod in cls.modules" :key="mod.id" class="module-badge">
                                <div class="file-icon" @click="openFile(mod.url)">
                                    <img src="../assets/img/icon-file.png" width="20px" />
                                </div>
                                <div class="file-name" :title="mod.name" @click="openFile(mod.url)">
                                    {{ mod.name }}
                                </div>
                                <button class="btn btn-sm btn-danger ml-2" @click.stop="showConfirmPopup(mod.id, cls.scheduleId, cls)">
                                                  X
                                                </button>
                            </div>
                        </div>

                        
                    </div>
    
                    <!-- Buttons -->
                    <div class="action-buttons">
    
                      
                        <button class="edit-btn" @click="openEditClass(cls)">
                                               Edit Class
                                            </button>
                        <!-- <button class="upload-btn" v-if="cls.zoomLink && cls.zoomLink !== 'no link'" @click="openZoomLink(cls.zoomLink)">
                                    Zoom Link
                                </button> -->
                        <button class="upload-btn" @click="openZoomLinkPopup(cls)">
                                    Zoom Link
                                </button>
    
                                <button class="upload-btn" @click="openUploadPopup(cls.scheduleId, idx)">
  Upload Notes
</button>

<button class="upload-btn" @click="openUploadPopupAnnouncement(cls.scheduleId, idx)">
Announcement
</button>
                    </div>
                </div>
    
            </div>
    
            <div v-else class="no-class">
                <p>No class scheduled for this date.</p>
            </div>
        </div>
    
    
        <!-- Add Schedule Modal -->
        <div v-if="popupscheduledetail" class="modal-backdrop">
            <div class="modal-card popup-all1 p-0">
    
                <!-- Header -->
                <div class="modal-header">
                    <h4>Add Schedule</h4>
                    <img src="../assets/img/close.png" class="close-btn" @click="closePopupCreate" />
                </div>
    
                <!-- Body -->
                <div class="modal-body">
    
                    <!-- Schedule Name -->
                    <div class="form-group">
                        <label>Schedule Name</label>
                        <v-select v-model="selectedSubjects" :options="subjectsData" label="Name" placeholder="--Please Select Subject--" class="modern-vselect"></v-select>
                    </div>
    
                    <!-- Repeat Interval -->
                    <div class="repeat-week-wrapper">
                        <div class="repeat-week">
                            <label>Repeat Every</label>
                            <CInput type="number" v-model="intervals" min="1" class="full-width-input" />
                            <span>week(s)</span>
                        </div>
                        <small class="helper-text">Use 24 Hour for Safari only</small>
                    </div>
    
                    <!-- Start & End Time -->
                    <CRow class="time-row">
                        <CCol sm="6">
                            <label>Start Time</label>
                            <CInput type="datetime-local" v-model="ScheduleDateTimes" />
                        </CCol>
                        <CCol sm="6">
                            <label>End Time</label>
                            <CInput type="datetime-local" v-model="ScheduleDateTimeEnds" />
                        </CCol>
                    </CRow>
    
                    <!-- Theme Color -->
                    <div>
                        <label>Theme Color</label>
                        <v-select v-model="selectedColor" :options="optionsColor" placeholder="--Please Select Theme--" class="custom-vselect no-bordered" label="Name"></v-select>
                    </div>
    
                    <!-- Teacher -->
                    <div class="form-group">
                        <label>Teacher</label>
                        <v-select v-model="selectedTeacher" :options="teachers" label="Name" placeholder="--Please Select Teacher--"></v-select>
                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-end gap-2">
                    <CButton color="info" class="custom-btn-grey text-dark" @click="closePopupCreate">
                        X
                    </CButton>
                    <CButton color="primary" class="btn-modern" @click="SubmitSchedule">
                        Save
                    </CButton>
                </div>
            </div>
        </div>
    
        <!-- Edit Class Modal -->
        <div v-if="popupEditClass" class="modal-backdrop">
            <div class="modal-card popup-all1 p-0">
                <div class="modal-header">
                    <h4>Edit Class</h4>
                    <img src="../assets/img/close.png" class="close-btn" @click="closeEditPopup" />
                </div>
    
                <div class="modal-body">
                    <CRow>
                        <CCol sm="2">
                            <img :src="photoURLteacher" width="50px" height="50px" style="border-radius: 30px" />
                        </CCol>
                        <CCol sm="10">
                            <h5>
                                <strong>{{ teacherName }}</strong>
                            </h5>
                            {{ SubjectName }}
                        </CCol>
                    </CRow>
    
                    <CRow class="time-row">
                        <CCol sm="6">
                            <label>Start Time</label>
                            <CInput type="datetime-local" v-model="editData.start" />
                        </CCol>
                        <CCol sm="6">
                            <label>End Time</label>
                            <CInput type="datetime-local" v-model="editData.end" />
                        </CCol>
                    </CRow>
                </div>
    
                <div class="modal-footer d-flex justify-content-end gap-2">
                    <CButton color="secondary" class="custom-btn-grey text-dark" @click="closeEditPopup">
                        Cancel
                    </CButton>
                    <CButton color="primary" class="btn-modern" @click="updateClass(editData.id)">
                        Save Changes
                    </CButton>
                </div>
            </div>
        </div>
    
        <div v-if="showUploadPopup" class="upload-popup-overlay" @click.self="closeUploadPopup">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closeUploadPopup">×</button>
    
                <br />
    
                <div class="upload-dropzone" @click="triggerFileInput" @dragover.prevent @drop.prevent="handleDrop">
                    <input type="file" ref="fileInput" multiple @change="handleFiles" style="display:none" />
                    <div class="upload-content">
                        <img src="../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
                        <p class="upload-text">Browse File</p>
                    </div>
                    <p class="upload-subtitle">Choose a file or drag & drop it here</p>
                    <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
                </div>
    
                <!-- ✅ File List -->
                <ul class="file-list" v-if="uploadedFiles.length">
                    <li v-for="(file, fileIdx) in uploadedFiles" :key="fileIdx">
                        <span class="file-name">
                          <i class="fa fa-paperclip"></i> {{ file.name }}
                        </span>
                        <button class="remove-file" @click="removeFile(fileIdx)">×</button>
                    </li>
                </ul>
    
                <!-- ✅ Upload Button -->
                <button class="upload-submit-btn" :disabled="!uploadedFiles.length || isUploading" @click="submitFiles">
                      {{ isUploading ? 'Uploading...' : 'Upload' }}
                    </button>
            </div>
        </div>

        <div v-if="showUploadPopupAnouncement" class="upload-popup-overlay" @click.self="closeUploadPopupAnnouncement">
            <div class="upload-popup-card">
                <button class="close-btn" @click="closeUploadPopupAnnouncement">×</button>
    
                <br />
                <CRow class="time-row text-left">
                        <CCol sm="12">
                            <label>Reschedule Date</label>
                            <CInput type="date" v-model="startReschedule" />
                        </CCol>
                        <CCol sm="6" class="mt-2">
                            <label>Start Time</label>
                            <CInput type="time" v-model="startTimeReschedule" />
                        </CCol>
                        <CCol sm="6" class="mt-2">
                            <label>End Time</label>
                            <CInput type="time" v-model="endTimeReschedule" />
                        </CCol>
                        <CCol sm="12" class="mt-2">
                            <label>Note</label>
                            <CTextarea rows="9" v-model="announcementNote"/>
                        </CCol>
                    </CRow>
                    <button class="upload-submit-btn" @click="submitAnnouncement">
                   Save
                    </button>
    
            </div>
        </div>
    
        <!-- Custom Confirm Popup -->
        <div v-if="isConfirm" class="popup-all backdrop-all">
            <div class="popup-all1">
                <div class="text-center">
                    <img style="max-width:70px" src="../assets/img/confirm.jpg" />
                    <h4 class="mt-5">Confirmation!</h4>
                    <h5 class="text-center">Are you sure you want to delete this module?</h5>
                    <div class="">
                        <CButton class="start-btn mr-2 mt-3" @click="confirmDeleteModule">Yes, Sure</CButton>
                        <CButton class="upload-btn" @click="cancelDelete">Cancel</CButton>
                    </div>
                </div>
            </div>
        </div>
    
    
        <!-- ✅ Zoom Link Popup -->
        <div v-show="popupZoomLink" class="modal-backdrop">
  <div class="modal-card popup-all1 p-0">
    <div class="modal-header">
      <h4>Zoom Details</h4>
      <img src="../assets/img/close.png" class="close-btn" @click="closeZoomPopup" />
    </div>

    <div class="modal-body">
      <div>
        <label>Zoom Meeting ID</label>
        <CInput v-model="zoomForm.meetingId" placeholder="Enter Zoom Meeting ID" />
      </div>

      <div>
        <label>Zoom Password</label>
        <CInput v-model="zoomForm.password" placeholder="Enter Zoom Password" />
      </div>

      <div>
        <label>Zoom Link</label>
        <CInput v-model="zoomForm.zoomLink" placeholder="Enter Zoom Link" />
      </div>

      <div>
        <label>Additional Notes / Links</label>
        <tinymce  id="d1"
        v-model="zoomForm.additionalLink"
        :init="tinymceConfig"
        style="height: 300px"></tinymce>
      </div>
    </div>

    <div class="modal-footer d-flex justify-content-end gap-2">
      <CButton color="secondary" class="custom-btn-grey text-dark" @click="closeZoomPopup">
        Cancel
      </CButton>
      <CButton color="primary" class="btn-modern" @click="saveZoomLink">
        Save
      </CButton>
    </div>
  </div>
</div>
    </div>
    
</template>


<script>
import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';
Vue.use(require("vue-moment"));
Vue.use(require("vue-moment"));
import moment from "moment";
Vue.use(VuejsDialog);
import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination,
} from "hooper";

export default {
    name: "ProgressBars",
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        HooperPagination
    },
    data() {
        return {
            counter: 73,
            max: 100,
            max2: 50,
            value: 33.333333333,
            value3: 75,
            bars: [
                { color: "success", value: 75 },
                { color: "info", value: 75 },
                { color: "warning", value: 75 },
                { color: "danger", value: 75 },
                { color: "primary", value: 75 },
                { color: "secondary", value: 75 },
                { color: "dark", value: 75 },
            ],
            timer: null,
            striped: true,
            animate: true,
            max3: 100,
            values: [15, 30, 20],

            user: {},
            childs: [],
            studentProfileAuthorize: "",
            selectedColor: "",



            //calendar
            currentDate: new Date(),
            selectedDate: null,
            weekDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

            classes: {},
            showUploadPopup: false,
            selectedClassIndex: null,
            uploadedFiles: [],
            isUploading: false,
            selectedScheduleId: null, // ✅ add this
            uploadedFilesMap: {},
            activeUploadClassIndex: null,

            isConfirm: false, // controls popup visibility
            moduleToDelete: null, // module id to delete
            scheduleIdToDelete: null, // schedule id for API
            clsToDelete: null, // reference to class object
            showAddSchedulePopup: false,
            newSchedule: {
                repeat: '',
                startTime: '',
                endTime: '',
                themeColor: 'red',
                teacherId: '',
            },
            teachers: [], // populate from API
            selectedSubjects: "",
            subjectsData: [],
            teachers: [],
            optionsColor: [{
                    Id: 1,
                    Name: "blue",
                },
                {
                    Id: 2,
                    Name: "red",
                },
                {
                    Id: 3,
                    Name: "green",
                },
                {
                    Id: 4,
                    Name: "purple",
                },
                {
                    Id: 5,
                    Name: "violet",
                },
            ],
            popupscheduledetail: false,
            selectedTeacher: "",
            ScheduleDateTimes: "",
            ScheduleDateTimeEnds: "",
            intervals: 1,

            popupEditClass: false,
            editData: {
                id: null,
                subject: null,
                start: '',
                end: '',
                teacher: null,
                color: null,
            },

            SelectedScheduleDateTime: "",
            SelectedScheduleDateTimeEnd: "",


            //zoom
            popupZoomLink: false,
            zoomForm: {
                scheduleId: null,
                zoomLink: "",
                password: "",
                meetingId: "",
                additionalLink: "",
            },
            tinymceConfig: {
                height: 200,
                menubar: false,
                plugins: 'link lists table',
                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link',
                setup(editor) {
                    editor.on('change keyup', () => {
                        editor.save(); // ensures v-model updates
                    });
                }
            },
            showUploadPopupAnouncement: false,
            announcementNote: "",
            startReschedule: "",
            startTimeReschedule:"",
            endTimeReschedule: ""


        };
    },
    computed: {
        monthYear() {
            return this.currentDate.toLocaleString("default", {
                month: "long",
                year: "numeric",
            });
        },
        daysInMonth() {
            const year = this.currentDate.getFullYear();
            const month = this.currentDate.getMonth();
            const firstDay = new Date(year, month, 1);
            const lastDay = new Date(year, month + 1, 0);

            const days = [];
            const startDay = firstDay.getDay();

            for (let i = 0; i < startDay; i++) {
                days.push({ day: "", date: null });
            }

            for (let d = 1; d <= lastDay.getDate(); d++) {
                const dateStr = `${year}-${(month + 1)
            .toString()
            .padStart(2, "0")}-${d.toString().padStart(2, "0")}`;
                days.push({ day: d, date: dateStr });
            }
            return days;
        },
        selectedClasses() {
            return this.classes[this.selectedDate] || [];
        },
        sortedClasses() {
            if (!this.selectedClasses) return [];
            return [...this.selectedClasses].sort((a, b) => {
                const timeA = moment(a.startTime, ["hh:mm A", "HH:mm"]);
                const timeB = moment(b.startTime, ["hh:mm A", "HH:mm"]);
                return timeA - timeB;
            });
        }
    },
    watch: {
        SelectedScheduleDateTime(newVal) {
            // Convert newVal to the desired format before updating the v-model
            this.SelectedScheduleDateTime = convertToISOFormat(newVal);
        },
        SelectedScheduleDateTimeEnd(newVal) {
            // Convert newVal to the desired format before updating the v-model
            this.SelectedScheduleDateTimeEnd = convertToISOFormat(newVal);
        },
    },
    async mounted() {
        this.showSidebar = window.innerWidth >= 768
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();
            this.GetSubject();
            this.GetTeacher();
        } else {
            this.GoToLogin();
        }
    },

    methods: {
        capitalize(text) {
            if (!text) return ''
            return text.charAt(0).toUpperCase() + text.slice(1)
        },
        handleSidebarClose() {
            if (window.innerWidth < 768) {
                this.showSidebar = false;
            }
        },
        toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetailWebs, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetAuthorizeProfile(this.user.id);
                        this.GetListChild(this.user.id);
                        this.GetWalletAmount(this.user.id);
                        this.GetTotalPaidAndUnpaid(this.user.id);
                        this.GetListWallet(this.user.id);
                        this.GetPaymentList(this.user.id);
                    }
                });
        },

        GetListChild() {
            this.$API
                .get(this.$AllStudentListAuthorize + "?id=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.childs = response.data;
                        this.getPicChild(this.childs);
                    }
                });
        },

        GetWalletAmount() {
            this.$API
                .get(this.$EwalletAmount + "?id=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.wallet = response.data;
                    }
                });
        },

        getPicChild(index) {
            return (
                this.childs.Students[index].profileImagePath
            );
        },

        GetAuthorizeProfile() {
            this.$API
                .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.studentProfileAuthorize = response.data;
                        this.photoURL =
                            "https://www.flyhigh.my/" + this.studentProfileAuthorize;
                    }
                });
        },


        GoToEditProfile() {
            this.$router.push("../EditProfile");
        },
        isToday(dateStr) {
            const today = new Date();
            const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
            return dateStr === todayStr;
        },
        // selectDate(dateStr) {
        //     if (dateStr) {
        //         this.selectedDate = dateStr;
        //         const classesForDate = this.classes[dateStr] || [];
        //         classesForDate.forEach(cls => {
        //             if (!cls.modules) cls.modules = [];
        //             this.fetchUploadedFiles(cls.scheduleId).then(files => {
        //                 cls.modules = files; // now guaranteed to have name/url
        //             });
        //         });
        //     }
        // },
        selectDate(dateStr) {
            if (!dateStr) return;

            this.selectedDate = dateStr;

            this.resetNewSchedule();

            this.selectedColor = null;
            this.selectedTeacher = null;
            this.selectedSubjects = null;
            this.ScheduleDateTimes = dateStr + "T08:00";
            this.ScheduleDateTimeEnds = dateStr + "T09:00";
            this.intervals = 1;
        },
        resetNewSchedule() {
            this.selectedSubjects = null;
            this.selectedColor = null;
            this.selectedTeacher = null;
            this.ScheduleDateTimes = "";
            this.ScheduleDateTimeEnds = "";
            this.intervals = 1;
        },
        prevMonth() {
            this.currentDate = new Date(
                this.currentDate.getFullYear(),
                this.currentDate.getMonth() - 1,
                1
            );
        },
        nextMonth() {
            this.currentDate = new Date(
                this.currentDate.getFullYear(),
                this.currentDate.getMonth() + 1,
                1
            );
        },
        goToday() {
            this.currentDate = new Date();
            this.selectedDate = this.currentDate
                .toISOString()
                .split("T")[0];
        },
        formatDisplayDate(dateStr) {
            const d = new Date(dateStr);
            return d.toLocaleDateString("en-MY", {
                day: "numeric",
                month: "long",
                year: "numeric",
            });
        },
        handleSidebarClose() {
            if (window.innerWidth < 768) {
                this.showSidebar = false;
            }
        },
        toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetailWebs, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetAuthorizeProfile(this.user.id);
                        this.GetListTimetable(this.user.id); // ✅ Add this line
                    }
                });
        },



        GetListTimetable() {
            this.$API
                .get(this.$GetScheduleTcFlyhighs, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.classes = response.data.classes;

                        // Ensure every class has modules array
                        Object.values(this.classes).forEach(dayClasses => {
                            dayClasses.forEach(cls => {
                                if (!cls.modules) cls.modules = [];
                            });
                        });

                        // ✅ Auto-select today's date
                        const today = new Date();
                        const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1)
                  .toString()
                  .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
                        this.selectedDate = todayStr;

                        // ✅ Preload today’s class list (and fetch uploaded files)
                        const classesForToday = this.classes[todayStr] || [];
                        classesForToday.forEach(cls => {
                            if (cls.scheduleId) {
                                this.fetchUploadedFiles(cls.scheduleId).then(files => {
                                    cls.modules = files;
                                });
                            }
                        });
                    }
                });
        },
        openZoomLink(link) {
            if (link && link !== "no link" && link !== "null") {
                window.open(link, "_blank"); // Opens in new tab
            } else {
                this.$dialog.alert("No Zoom link available for this class."); // optional if using SweetAlert
            }
        },
        startClass(link) {
            if (link && link !== "no link") {
                window.open(link, "_blank");
            } else {
                alert("No Zoom link available!");
            }
        },
        openUploadPopup(scheduleId, idx) {
  // Always save these two before showing popup
  this.selectedScheduleId = scheduleId;
  this.selectedClassIndex = idx;

  console.log("✅ Upload opened for schedule:", scheduleId, "at index:", idx);

  this.showUploadPopup = true;
  this.uploadedFiles = []; // reset any previous selection
},
        closeUploadPopup() {
            this.showUploadPopup = false;
            this.selectedClassIndex = null;
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFiles(event) {
            const files = event.target.files;
            for (let i = 0; i < files.length; i++) {
                this.uploadedFiles.push(files[i]);
            }
        },
        handleDrop(event) {
            const files = event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                this.uploadedFiles.push(files[i]);
            }
        },
        removeFile(index) {
            this.uploadedFiles.splice(index, 1);
        },
        async submitFiles() {
    if (!this.uploadedFiles.length) {
        this.$dialog.alert("No files selected", "Please choose files to upload.", "warning");
        return;
    }

    this.isUploading = true;

    try {
        const formData = new FormData();
        this.uploadedFiles.forEach(file => {
            formData.append("files", file);
        });

        // Upload files
        const res = await this.$API.post(this.$UploadModuleFile, formData, {
            withCredentials: true,
            timeout: 600000
        });

        if (res.status === 200 && res.data) {
            const result = Array.isArray(res.data) ? res.data : [res.data];
            const fileIds = result
                .filter(item => item && item.fileId)
                .map(item => parseInt(item.fileId, 10));

            if (!fileIds.length) throw new Error("No file IDs returned from upload.");

            // Assign uploaded files to this schedule
            const assignRes = await this.$API.post(this.$AssignModuleFiles, {
                fileIds,
                scheduleId: this.selectedScheduleId,
            });

            if (assignRes.status === 200) {
  const selectedClass = this.selectedClasses[this.selectedClassIndex];

  if (!selectedClass) {
    console.warn("⚠️ No selected class found at index", this.selectedClassIndex);
    this.$dialog.alert("Something went wrong — please reopen the upload popup.");
    return;
  }

  // ✅ Fetch and update only that schedule’s modules
  const newModules = await this.fetchUploadedFiles(this.selectedScheduleId);
  this.$set(selectedClass, 'modules', newModules);

  this.$dialog.alert("Notes uploaded successfully!");
  this.closeUploadPopup();
  window.location.reload();

}
 else {
                throw new Error("Failed to assign files to schedule.");
            }
        } else {
            throw new Error("Upload failed — no response from server.");
        }

    } catch (err) {
        console.error(err);
    } finally {
        this.isUploading = false;
        this.uploadedFiles = [];
    }
},
        async fetchUploadedFiles(scheduleId) {
            try {
                const res = await this.$API.get(`${this.$GetListModuleFile}?scheduleId=${scheduleId}`, {
                    withCredentials: true
                });

                if (res.status === 200 && res.data) {
                    // Map the backend response to {id, name, url} for Vue
                    const modules = res.data.map(f => ({
                        id: f.id,
                        name: f.fileName || "Unnamed File",
                        url: f.fileUrl || "#"
                    }));

                    // Save to map for reference if needed
                    this.$set(this.uploadedFilesMap, scheduleId, modules);

                    return modules;
                }
                return [];
            } catch (err) {
                console.error("Failed to fetch module files:", err);
                return [];
            }
        },
        openFile(fileUrl) {
            if (!fileUrl || fileUrl === "#") {
                console.warn("This file has no valid URL:", fileUrl);
                return alert("No file link found for this module.");
            }

            // If fileUrl already starts with http, open directly
            const fullUrl = fileUrl.startsWith("http") ?
                fileUrl :
                `https://s3.ap-southeast-5.amazonaws.com/flyhighfiles/${fileUrl}`;

            window.open(fullUrl, "_blank");
        },
        showConfirmPopup(moduleId, scheduleId, cls) {
            this.moduleToDelete = moduleId;
            this.scheduleIdToDelete = scheduleId;
            this.clsToDelete = cls;
            this.isConfirm = true;
        },

        // Called when user clicks OK
        async confirmDeleteModule() {
            if (!this.moduleToDelete || !this.scheduleIdToDelete || !this.clsToDelete) return;

            try {
                const formData = new FormData();
                formData.append("id", this.moduleToDelete);
                formData.append("scheduleId", this.scheduleIdToDelete);

                const res = await this.$API.post(this.$DeleteModule, formData, {
                    withCredentials: true,
                });

                if (res.status === 200) {
                    // Remove module from UI
                    this.clsToDelete.modules = this.clsToDelete.modules.filter(mod => mod.id !== this.moduleToDelete);
                    this.$dialog.alert("Success delete notes");
                } else {
                    alert('Failed to delete module.');
                }
            } catch (err) {
                console.error(err);
                alert('Error deleting module.');
            } finally {
                this.resetConfirmPopup();
            }
        },

        // Called when user clicks Cancel
        cancelDelete() {
            this.resetConfirmPopup();
        },

        resetConfirmPopup() {
            this.isConfirm = false;
            this.moduleToDelete = null;
            this.scheduleIdToDelete = null;
            this.clsToDelete = null;
        },
        //selecteddate
        openAddSchedulePopup() {
            this.showAddSchedulePopup = true;
            // optionally fetch teachers here
            this.loadTeachers();
        },
        closeAddSchedulePopup() {
            this.showAddSchedulePopup = false;
            this.resetNewSchedule();
        },

        loadTeachers() {
            // Example API call
            this.$API.get('/teachers').then(res => {
                this.teachers = res.data;
            });
        },
        submitNewSchedule() {
            if (!this.newSchedule.startTime || !this.newSchedule.endTime || !this.newSchedule.teacherId) {
                alert('Please fill in all required fields!');
                return;
            }

            const payload = {
                date: this.selectedDate,
                repeat: this.newSchedule.repeat,
                startTime: this.newSchedule.startTime,
                endTime: this.newSchedule.endTime,
                themeColor: this.newSchedule.themeColor,
                teacherId: this.newSchedule.teacherId,
            };

            // send to backend
            this.$API.post('/schedules', payload).then(res => {
                this.closeAddSchedulePopup();
                this.refreshCalendar(); // re-fetch schedules for this date
            });
        },
        formatDisplayDate(date) {
            return new Date(date).toLocaleDateString();
        },
        refreshCalendar() {
            // reload schedules for selectedDate
            this.GetScheduleStudent();
        },
        async SubmitSchedule() {
            // Debug log
            console.log("Subjects:", this.selectedSubjects);
            console.log("Teacher:", this.selectedTeacher);
            console.log("Color:", this.selectedColor);
            console.log("Start:", this.ScheduleDateTimes, "End:", this.ScheduleDateTimeEnds);
            console.log("Interval:", this.intervals);


            const formData = new FormData();
            formData.append("TuitionSubjectId", this.selectedSubjects.SubjectId);
            formData.append("ScheduleDateTime", this.ScheduleDateTimes);
            formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnds);
            formData.append("TeacherId", this.selectedTeacher.Id);
            formData.append("ThemeColor", this.selectedColor.Name);
            formData.append("interval", this.intervals);

            return this.$API
                .post(this.$InsertScheduleNew, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.popupscheduledetail = false;
                        this.$dialog.alert("Schedule Created!");
                        this.GetListTimetable();
                        this.Busy = false;
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to save ").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        GetSubject() {
            return this.$API
                .get(this.$GetListSubjectTc, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.subjectsData = response.data;
                    }
                });
        },
        GetTeacher() {
            this.Busy = true;
            this.$API
                .get(this.$ViewTeacher, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.Busy = false;
                        this.teachers = response.data.filter((teacher) => teacher.Status === 'active');
                        this.getPic(this.teachers);
                    }
                });
        },

        getPic(option) {
            return "https://www.flyhigh.my" + option.profileImagePath;
        },
        closePopupCreate() {
            this.popupscheduledetail = false;
        },
        onColorSelect(color) {
            this.selectedColor = color; // ensure selectedColor is the full object
            console.log("Selected color:", color);
        },
        GoOpenSchedule() {
            this.popupscheduledetail = true;
        },
        openEditClass(cls) {
            this.$API
                .get(`${this.$EditSchedule}?scheduleId=${cls.scheduleId}`, { withCredentials: true })
                .then((response) => {
                    this.info = response.data;
                    console.log(this.info);

                    if (response.status == 200 && this.info) {
                        this.ClassName = this.info.ClassName;
                        this.SubjectName = this.info.SubjectName;
                        this.SelectedScheduleDateTime = this.info.ScheduleDateTime;
                        this.SelectedScheduleDateTimeEnd = this.info.ScheduleDateTimeEnd;
                        this.TuitionSubjectID = this.info.TuitionSubjectID;
                        this.picturePath = this.info.profileImagePath;
                        this.teacherName = this.info.TeacherName;
                        this.photoURLteacher = "https://www.flyhigh.my/" + this.picturePath;

                        // ✅ Pre-fill editData using backend info
                        this.editData = {
                            id: this.info.ScheduleId || cls.scheduleId,
                            subject: this.subjectsData.find(s => s.SubjectId === this.info.TuitionSubjectID) || null,
                            start: this.info.ScheduleDateTime ? this.info.ScheduleDateTime.replace(" ", "T") : '',
                            end: this.info.ScheduleDateTimeEnd ? this.info.ScheduleDateTimeEnd.replace(" ", "T") : '',
                            teacher: this.teachers.find(t => t.Id === this.info.TeacherId) || null,
                            color: this.optionsColor.find(c => c.Name === this.info.ThemeColor) || null,
                        };

                        this.popupEditClass = true;
                    } else {
                        console.log(this.info.detail);
                    }
                })
                .catch(err => console.error(err));
        },
        closeEditPopup() {
            this.popupEditClass = false;
        },
        //         async updateClass(id) {
        //   try {
        //     // ✅ Don't fetch old data again
        //     if (this.SelectedScheduleDateTime >= this.SelectedScheduleDateTimeEnd) {
        //       this.errorDate = true;
        //       this.labelMessageError =
        //         this.SelectedScheduleDateTime > this.SelectedScheduleDateTimeEnd
        //           ? "Error: End Date is less than Start Date"
        //           : "Error: End Date is equal to Start Date";
        //       return;
        //     }

        //     // ✅ Use values from your edit form or component state
        //     const formData = new FormData();
        //     formData.append("Id", id);
        //     formData.append("TuitionSubjectId", this.TuitionSubjectID);
        //     formData.append("ScheduleDateTime", this.SelectedScheduleDateTime);
        //     formData.append("ScheduleDateTimeEnd", this.SelectedScheduleDateTimeEnd);

        //     // ✅ Send update
        //     const res = await this.$API.post(this.$UpdateSchedules, formData, { withCredentials: true });

        //     if (res.status === 200) {
        //     //  this.$dialog.alert("Success", "Class updated successfully!", "success");
        //       this.popupEditClass = false;

        //       this.GetScheduleStudent();

        //       this.$dialog.alert("Class updated successfully!");
        //     }
        //   } catch (err) {
        //     console.error("Error updating class:", err);
        //     this.$dialog.alert("Failed to update class");
        //   }
        // }
        async updateClass(id) {
            try {
                const formData = new FormData();

                // Format to match backend expectation
                const formattedStart = moment(this.editData.start).format("DD/MM/YYYY HH:mm");
                const formattedEnd = moment(this.editData.end).format("DD/MM/YYYY HH:mm");

                // Append fields with correct names
                formData.append("scheduleID", id);
                formData.append("scheduleTime", formattedStart);
                formData.append("scheduleTimeEnd", formattedEnd);

                const res = await this.$API.post(this.$UpdateSchedules, formData, {
                    withCredentials: true,
                });

                if (res.status === 200) {
                    this.popupEditClass = false; // ✅ close modal
                    await this.GetListTimetable(); // ✅ refresh schedule list


                    // ✅ show dialog or swal after success
                    if (this.$dialog) {
                        this.$dialog.alert("✅ Schedule successfully saved!");
                    } else if (this.$dialog.alert) {
                        this.$dialog.alert("Success", "Schedule successfully saved!", "success");
                    } else {
                        alert("Schedule successfully saved!");
                    }
                }
            } catch (err) {
                console.error("Error updating class:", err);
            }
        },
        getClassCount(dateStr) {
            if (!dateStr || !this.classes) return 0;
            const dayClasses = this.classes[dateStr];
            return Array.isArray(dayClasses) ? dayClasses.length : 0;
        },
        openZoomLink(link) {
            if (link && link !== "no link" && link !== "null") {
                window.open(link, "_blank"); // Opens in new tab
            } else {
                this.$swal("No Zoom link available for this class."); // optional if using SweetAlert
            }
        },
        openZoomLinkPopup(cls) {
            this.popupZoomLink = true;

            // Fill in existing zoom data (if any)
            Object.assign(this.zoomForm, {
  scheduleId: cls.scheduleId,
  zoomLink: cls.zoomLink !== 'no link' ? cls.zoomLink : '',
  password: cls.password !== 'null' ? cls.password : '',
  meetingId: cls.meetingId !== 'null' ? cls.meetingId : '',
  additionalLink: cls.additionalLink || '', // ✅ will show now
  subjectId: cls.subjectId,
  teacherId: cls.teacherId,
});
        },
        closeZoomPopup() {
            this.popupZoomLink = false;
            Object.assign(this.zoomForm, {
                scheduleId: null,
                zoomLink: "",
                password: "",
                meetingId: "",
                additionalLink: "",
                subjectId: null,
                teacherId: null,
            });
        },
        async saveZoomLink() {
            if (!this.zoomForm.scheduleId) {
                this.$dialog.alert("Missing schedule ID!", "Error", "error");
                return;
            }

            const payload = {
                scheduleId: this.zoomForm.scheduleId,
                vcLink: this.zoomForm.zoomLink,
                password: this.zoomForm.password,
                meetingId: this.zoomForm.meetingId,
                additionalLink: this.zoomForm.additionalLink,
                subjectId: this.zoomForm.subjectId,
                teacherId: this.zoomForm.teacherId,
            };

            try {
                const res = await this.$API.post(this.$SubmitVCZoomDetails, payload, { withCredentials: true });
                if (res.status === 200) {
                  
                    this.closeZoomPopup();
                    this.GetListTimetable(); // refresh the class list
                }
            } catch (err) {
                console.error(err);
                this.$dialog.alert("Error", "Failed to save Zoom details.", "error");
            }
        },
        openUploadPopupAnnouncement(scheduleId) {
            this.selectedScheduleId = scheduleId;
            this.showUploadPopupAnouncement = true;
        },
        closeUploadPopupAnnouncement()
        {
            this.showUploadPopupAnouncement = false; 
        },
        async submitAnnouncement() {

        if (!this.selectedScheduleId) {
            this.$dialog.alert("Schedule not found!");
            return;
        }

        const fullStartDateTime = `${this.startReschedule}T${this.startTimeReschedule}`;
    const fullEndDateTime = `${this.startReschedule}T${this.endTimeReschedule}`;

        const payload = {
            scheduleId: this.selectedScheduleId,
            rescheduleDate: this.startReschedule,
            startTime: fullStartDateTime,
            endTime: fullEndDateTime,
            note: this.announcementNote
        };

        try {
            const res = await this.$API.post(
                this.$BlastScheduleAnnouncement,
                payload,
                { withCredentials: true }
            );

            if (res.status === 200) {
                this.$dialog.alert("Announcement blasted successfully!");
                this.closeUploadPopupAnnouncement();
            }

        } catch (err) {
            console.error(err);
            this.$dialog.alert("Failed to blast announcement");
        }
        }

    },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.calendar-wrapper {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    /* make it span full available width */
    margin: 20px 0;
    /* spacing top & bottom */
    box-sizing: border-box;
    /* include padding in width calculation */
}

/* Header */

.calendar-headers {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.left-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.left-controls button {
    background: #f3f4f6;
    border: none;
    border-radius: 6px;
    padding: 6px 10px;
    cursor: pointer;
    font-weight: 600;
}

.month-title {
    font-size: 18px;
    font-weight: 600;
}

.today-btn {
    background: #2563eb;
    color: white;
}

/* Calendar Grid */

.calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-bottom: 20px;
}

.day {
    text-align: center;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
}

.day.header {
    font-weight: 600;
    color: #6b7280;
    background: #f9fafb;
}

.day:hover {
    background: #f3f4f6;
}

.today {
    background: #e0e7ff;
    border: 1px solid #2563eb;
}

.selected {
    background: #2563eb;
    color: white;
}

/* Schedule Section */

.schedule-container {
    margin-top: 10px;
    background: #f9fafc;
    border-radius: 12px;
    padding: 15px;
}

.schedule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.schedule-header h3 {
    font-size: 18px;
    font-weight: 600;
}

.date-label {
    font-size: 14px;
    color: #6b7280;
}

.schedule-card {
    display: flex;
    align-items: flex-start;
    background: #fff;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    justify-content: space-between;
}

.time-label {
    width: 80px;
    font-weight: 600;
    font-size: 14px;
    color: #374151;
}

.class-info {
    flex: 1;
}

.class-status {
    color: #dc2626;
    font-size: 12px;
    margin-bottom: 5px;
}

.status-dot {
    width: 8px;
    height: 8px;
    background: #dc2626;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
}

.class-title {
    font-weight: 600;
    color: #111827;
}

.class-teacher {
    color: #4b5563;
    font-size: 14px;
}

.class-time {
    color: #6b7280;
    font-size: 13px;
}

.action-buttons {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex-wrap: wrap;
    /* allow wrapping if needed */
}

.start-btn,
.upload-btn {
    background: #2563eb;
    border: none;
    color: white;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 13px;
    cursor: pointer;
}

.upload-btn {
    background: white;
    color: #2563eb;
    border: 1px solid #2563eb;
}

.start-btn {
    background: #2563eb;
    color: #fff;
    border: 1px solid #fff;
}

/* Small screens: stack buttons vertically */

@media (max-width: 768px) {
    .action-buttons {
        flex-direction: column;
        gap: 6px;
        margin-top: 10px;
    }
    .start-btn,
    .upload-btn {
        width: 100%;
        display: block;
        font-size: 12px;
        padding: 5px 4px;
    }
}

.no-class {
    text-align: center;
    padding: 20px;
    color: #6b7280;
}

/* Responsive */

@media (max-width: 768px) {
    .calendar-grid {
        gap: 2px;
    }
    .day {
        padding: 8px 0;
    }
    .schedule-card {
        flex-direction: column;
        align-items: flex-start;
    }
    .action-buttons {
        flex-direction: row;
        width: 100%;
        justify-content: flex-end;
    }
}
</style>